export const ITEM_CONTROL_DIMENSIONS = {
  BORDER_THICKNESS: 2,
  DEFAULT_RECTANGLE_CONTROL_SIZE: 22,
  RECTANGLE_CONTROL_PADDING: 1,
  BOTTOM_MIDDLE_BUTTON_SIZE: 200,
  ROTATING_CONTROL_OFFSET: -30,
  UNLOCK_BUTTON_OFFSETY: -30,
  BOTTOM_BUTTONS_OFFSET: 28,
  DISABLED_OPACITY: 0.7,
  PMW_CONTROL_PADDING: 0,
  PMW_ITEM_LEGACY_PADDING: 11,
};
